'use strict';
if (!window.Nacl) { window.Nacl = {}; }

window.Nacl.Header = (function($) {
  var enableStickyHeader = false;
  var enableUserMenu = true;
  var stuckHeaderBreakpoint = 35;

  var $searchInput;
  var $searchForm;
  
  var $userContainer;
  var $userPopup;
  var userPopupShown = false;
  
  function isSearchVisible() {
    return $searchForm.hasClass('expanded');
  }
  
  function toggleHeaderSearch(onOff) {
    onOff = (undefined !== onOff) ? onOff : !isSearchVisible();
    
    if (onOff) {
      $searchForm.addClass('expanded');
      $searchInput.focus();
    }
    else {
      $searchForm.removeClass('expanded');
    }
  };
  
  function searchSubmit() {    
    $searchForm.submit();
  }
  
  function initStickyHeader() {
    if (!enableStickyHeader) { return; }
    
    /* Header Nav resizing on scroll */
    var $body = $(document.body);

    $(window).on('scroll', function(e){
      if (window.pageYOffset > stuckHeaderBreakpoint) {
        $body.addClass('header-is-stuck');
      } else {
        $body.removeClass('header-is-stuck');
      }
    });
  }
  
  function initHamburger() {
    /* Hamburger menu button */
    var $hamburgerHeader = $('#hdrHamburger'),
    $hamburgerEl = $('#nacl-mainNavHamburger');


    $hamburgerEl.click(function(e){
      e.preventDefault();
      $hamburgerHeader.addClass('expanded');
    });
    
    $hamburgerHeader.on('click', '.hdrHamburger__close', function() { 
      $hamburgerHeader.removeClass('expanded');
    });
  }
  
  function initHeaderSearch() {
    $searchForm = $('#nacl-headerSearch');
    $searchInput = $searchForm.find('input[type=text]');
    
    var $submit = $searchForm.find('.nacl-headerSearch__submit');

    // When expanded, the submit button acts as an actual submit.  Otherwise, it expands the search.
    $submit.on('click', function(e) { 
      if (isSearchVisible()) { 
        searchSubmit();
      }
      e.preventDefault;
      toggleHeaderSearch(true);
    });
    
    $searchInput.on('blur', function(e) { toggleHeaderSearch(false); });
    
    $searchInput.on('keypress', function(e) { 
      switch (e.keyCode) {
      // Return: Submit the form
      case 13:
        searchSubmit();
        break;
        
      // Esc: Close the searchbar
      case 27:
        toggleHeaderSearch(false);
        break;
      }
    });
  }
  
  function initUserMenu() {
    if (!enableUserMenu) { return; }
    
    $userContainer = $('.nacl-userBox');
    $userPopup = $userContainer.find('.nacl-header__userOptions');
    
    $userContainer.find('a.nacl-headerUtils__circle').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      userPopupShown = true;
      
      var $userPopup = $(e.currentTarget).siblings('.nacl-header__userOptions');
      $userPopup.show();
      $userPopup.css('display', 'flex');
    });

    $userPopup.find('.nacl-header__close a').on('click', function(e) {
      e.preventDefault();
      userPopupShown = false;
      $userPopup.hide();
    });

    $('body').on('click', function(e) {
      if (!userPopupShown) { return; }

      var target = e.originalEvent.originalTarget;
      
      if (!$(target).parents('.nacl-userBox').length) {
        userPopupShown = false;
        $userPopup.hide();
      }
    });
  }
  
  function init() {
    initStickyHeader();
    initHamburger();
    initHeaderSearch();
    initUserMenu();
  };

  $(init);
  
  return {
    toggleHeaderSearch: toggleHeaderSearch
  }
})(jQuery);
